import { cloneDeepObject } from '@/views/website/products/components/description/common/utils.js';

const parseHtml = htmlString => {
  const parser = new DOMParser();
  return parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
};

const defaultButton = {
  backgroundColor: '#606F99',
  color: '#FFFFFF',
  radius: 4,
  iconPrefix: {
    show: false,
    src: '',
  },
  iconSuffix: {
    show: false,
    src: '',
  },
  text: 'Shop Now',
  link: '#',
  show: true,
  subBtn: {
    show: false,
    text: '30-Day Money-Back Guararantee',
  },
};

export const extractButtonBasic = htmlString => {
  const doc = parseHtml(htmlString);
  const result = {
    ...cloneDeepObject(defaultButton),
  };

  const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
  if (wrapButtonEl) {
    result.show = wrapButtonEl.getAttribute('data-show') !== 'false';
  }

  const btnEl = doc.querySelector('[data-attribute="btn-link"]');
  if (btnEl) {
    result.link = btnEl.getAttribute('href') || result.link;
    result.backgroundColor = btnEl.getAttribute('data-background') || result.backgroundColor;
    result.color = btnEl.getAttribute('data-color') || result.color;
    result.radius = Number(btnEl.getAttribute('data-radius')) || result.radius;
  }
  const iconPrefixEl = doc.querySelector('[data-attribute="icon-prefix"]');
  if (iconPrefixEl) {
    result.iconPrefix.show = iconPrefixEl.getAttribute('data-show') !== 'false';
    result.iconPrefix.src =
      iconPrefixEl.querySelector('[data-attribute="icon-prefix-image"]')?.getAttribute('src') || result.iconPrefix.src;
  }
  const iconSuffixEl = doc.querySelector('[data-attribute="icon-suffix"]');
  if (iconSuffixEl) {
    result.iconSuffix.show = iconSuffixEl.getAttribute('data-show') !== 'false';
    result.iconSuffix.src =
      iconSuffixEl.querySelector('[data-attribute="icon-suffix-image"]')?.getAttribute('src') || result.iconSuffix.src;
  }
  const textEl = doc.querySelector('[data-attribute="text-btn"]');
  if (textEl) {
    result.text = textEl.textContent.trim() || result.text;
  }
  const subBtnEl = doc.querySelector('[data-attribute="sub-btn"]');
  if (subBtnEl) {
    result.subBtn.show = subBtnEl.getAttribute('data-show') !== 'false';
    result.subBtn.text = subBtnEl.textContent.trim() || result.subBtn.text;
  }
  return result;
};

export const updateButtonBasic = (wrapElement, updatedData) => {
  const show = !!updatedData.show;
  if (wrapElement) {
    wrapElement.setAttribute('data-show', show ? 'true' : 'false');
    wrapElement.style.display = show ? 'block' : 'none';
  }
  const btnEl = wrapElement.querySelector('[data-attribute="btn-link"]');
  if (btnEl) {
    btnEl.setAttribute('data-show', updatedData.show ? 'true' : 'false');
    btnEl.setAttribute('href', updatedData.link || '#');
    btnEl.setAttribute('data-background', updatedData.backgroundColor || '#606F99');
    btnEl.setAttribute('data-color', updatedData.color || '#FFFFFF');
    btnEl.setAttribute('data-radius', updatedData.radius || '4');
    btnEl.style.setProperty('background-color', updatedData.backgroundColor || '#606F99', 'important');
    btnEl.style.setProperty('color', updatedData.color || '#FFFFFF', 'important');
    btnEl.style.borderRadius = `${updatedData.radius}px`;
  }
  const iconPrefixEl = wrapElement.querySelector('[data-attribute="icon-prefix"]');
  if (iconPrefixEl) {
    const show = !!updatedData.iconPrefix?.show;
    iconPrefixEl.setAttribute('data-show', show ? 'true' : 'false');
    iconPrefixEl.style.display = show ? 'flex' : 'none';
    if (show) {
      iconPrefixEl
        .querySelector('[data-attribute="icon-prefix-image"]')
        .setAttribute('src', updatedData.iconPrefix.src);
    }
  }
  const iconSuffixEl = wrapElement.querySelector('[data-attribute="icon-suffix"]');
  if (iconSuffixEl) {
    const show = !!updatedData.iconSuffix?.show;
    iconSuffixEl.setAttribute('data-show', show ? 'true' : 'false');
    iconSuffixEl.style.display = show ? 'flex' : 'none';
    if (show) {
      iconSuffixEl
        .querySelector('[data-attribute="icon-suffix-image"]')
        .setAttribute('src', updatedData.iconSuffix.src);
    }
  }
  const textEl = wrapElement.querySelector('[data-attribute="text-btn"]');
  if (textEl) {
    textEl.textContent = updatedData.text || 'Shop Now';
  }
  const subBtnEl = wrapElement.querySelector('[data-attribute="sub-btn"]');
  if (subBtnEl) {
    subBtnEl.setAttribute('data-show', updatedData.subBtn?.show ? 'true' : 'false');
    subBtnEl.textContent = updatedData.subBtn?.text || '';
    subBtnEl.style.display = updatedData.subBtn?.show ? 'block' : 'none';
  }
  return wrapElement.outerHTML.trim();
};
